import { useContext } from "react";
import CustomerContext from "../context/customerProvider";

const useCustomerTabs = () => {
  const { tabs, setTabs } = useContext(CustomerContext);

  return {
    tabs,
    setTabs,
  };
};

export default useCustomerTabs;
